import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ReportClaim } from '../../models/report.interface';

@Component({
  selector: 'app-claims-list-card',
  templateUrl: './claims-list-card.component.html',
  styleUrls: ['./claims-list-card.component.scss']
})
export class ClaimsListCardComponent implements OnInit {
  @Input() title?: string
  @Input() isLoading = false;
  @Input() claims: ReportClaim[] | undefined = [];
  @Input() showLienHolder = false;
  @Input() showContractNumber = false;

  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  claimDetails(id?: number) {
    if (!id) {
      return;
    }
    this.router.navigate([`/dashboard/claims/claim-details/${id}`]);
  }

  getContractNumber(claim: ReportClaim): string {
    return claim?.contract_number || claim?.contract?.contract_number || 'N/A';
  }

}
